
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.09 3.636h-3.272v-1.09A2.545 2.545 0 0011.273 0H6.909a2.545 2.545 0 00-2.545 2.545v1.091H1.09a1.09 1.09 0 000 2.182h.364v12.364A1.818 1.818 0 003.273 20h11.636a1.818 1.818 0 001.818-1.818V5.818h.364a1.091 1.091 0 000-2.182zM6.546 2.546a.364.364 0 01.364-.364h4.364a.364.364 0 01.363.363v1.091h-5.09v-1.09zm8 15.272H3.636v-12h10.91v12zM8 8.728v5.818a1.09 1.09 0 11-2.182 0V8.727a1.091 1.091 0 012.182 0zm4.364 0v5.818a1.09 1.09 0 11-2.182 0V8.727a1.091 1.091 0 012.182 0z"}})])
          )
        }
      }
    